import { RG_TYPE } from '../../types/rg-type.js';

const DefaultWindow = {
    type: RG_TYPE.Window,
    modulousId: 'WNF|01|UK-WNF0002',
    size: [1, 0.7, 0.11],
    pos: [0, 0.75, 0],
    anchor: [0.5, 0, 0.5],
    name: 'window',
    children: [],
    alpha: 0.5,
    color: '#D2F3F0'
};

export { DefaultWindow };
//# sourceMappingURL=default-window.js.map
